module.exports = __webpack_public_path__ + "img/strategy-icon.8f0cbfe1.svg";